import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../../context/NavigationContext";
import * as Yup from "yup";
import ChannelCheckListCard from "./components/ChannelCheckListCard";
import { ActionItem, ActionOnItem, ChannelState, ChannelSubstate, getCreatorActionableItems, SKChannel, Tier } from "../../../models/SKChannel";
import { capitalizeFirstLetter } from "../../../utils/stringFunctions";
import { AddTextAreaField } from "../../../components/AddTextAreaField";
import { useAuth } from "../../../context/AuthContext";
import ImageInput from "../../artifacts/create/ImageInput";
import { FolderName } from "../../../api/shared/uploadService";
import { iso6392 } from "iso-639-2";
import { iso31661 } from "iso-3166";
import { CreateChannelContext } from "../../../context/CreateChannelContext";

import { SKSelectOption } from "../../../components/SKSelectOption";
import { AddTextField } from "../../../components/AddTextField";

//import ArtifactStateDialog, { DialoageContent } from "../../contentModeration/ArtifactStateDialog-Old";
import ArtifactStateDialog, { DialoageContent } from "../../artifacts/create/container/components/ArtifactStateDialog";

import PopupSingleButtonProps, { PopupActionStatus } from "../../../components/PopupSingleButton";

import { useLeftbarBar } from "../../../context/LeftSidebarContext";
import { EditChannelContext } from "../../../context/EditChannelContext";
import { Timestamp } from "firebase/firestore";
import { TopicTypeString } from "../../../models/SKArtifact";

import APILoader from "../../../components/APILoader";
import { ChannelSubscriptionType } from "./ChannelSubscriptionType";
import OptionSelect from "../../../components/OptionSelect";
import { PrimaryExternalLinkData } from "../../../utils";

export default function ChannelEditView() {
  const List_of_languages_to_be_displayed = [
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Armenian",
    "Assamese",
    "Aymara",
    "Azerbaijani",
    "Bashkir",
    "Basque",
    "Belarusian",
    "Bengali",
    "Bhojpuri",
    "Bosnian",
    "Breton",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Cebuano",
    "Chamorro",
    "Chichewa",
    "Chinese (Simplified)",
    "Chinese (Traditional)",
    "Chuvash",
    "Corsican",
    "Cree",
    "Croatian",
    "Czech",
    "Danish",
    "Dari",
    "Divehi",
    "Dogri",
    "Dutch",
    "Dzongkha",
    "English",
    "Esperanto",
    "Estonian",
    "Ewe",
    "Fijian",
    "Filipino (Tagalog)",
    "Finnish",
    "Flemish",
    "French",
    "Frisian",
    "Fulah",
    "Galician",
    "Georgian",
    "German",
    "Greek",
    "Guarani",
    "Gujarati",
    "Haitian Creole",
    "Hausa",
    "Hawaiian",
    "Hebrew",
    "Hindi",
    "Hmong",
    "Hungarian",
    "Icelandic",
    "Igbo",
    "Ilocano",
    "Indonesian",
    "Inuktitut",
    "Irish",
    "Italian",
    "Japanese",
    "Javanese",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Kinyarwanda",
    "Kirghiz",
    "Konkani",
    "Korean",
    "Kurdish",
    "Lao",
    "Latin",
    "Latvian",
    "Lingala",
    "Lithuanian",
    "Luxembourgish",
    "Macedonian",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Maltese",
    "Maori",
    "Marathi",
    "Mongolian",
    "Manipuri",
    "Nepali",
    "Norwegian",
    "Nyanja",
    "Odia (Oriya)",
    "Ojibwe",
    "Pashto",
    "Persian (Farsi)",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Romansh",
    "Russian",
    "Samoan",
    "Sanskrit",
    "Scots Gaelic",
    "Serbian",
    "Sesotho",
    "Shona",
    "Sindhi",
    "Sinhala",
    "Slovak",
    "Slovenian",
    "Somali",
    "Spanish",
    "Sundanese",
    "Swahili",
    "Swedish",
    "Tahitian",
    "Tajik",
    "Tamil",
    "Tatar",
    "Telugu",
    "Thai",
    "Tibetan",
    "Tigrinya",
    "Tok Pisin",
    "Tswana",
    "Turkish",
    "Turkmen",
    "Ukrainian",
    "Urdu",
    "Uyghur",
    "Uzbek",
    "Vietnamese",
    "Volapük",
    "Walloon",
    "Welsh",
    "Wolof",
    "Xhosa",
    "Yiddish",
    "Yoruba",
    "Zulu",
  ];

  const sortedExternalLinkOptions = PrimaryExternalLinkData.map(link => ({
    title: link.title,
    value: link.type,
  }));

  const location = useLocation();

  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});
  const authContext = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);

  const [isValidForm, setIsValidForm] = useState(false);
  // useEffect(() => {}, []);
  const navigate = useNavigate();
  const { setNavProps, showChildRouteAsModal } = useNavigationBar();
  const { setShowLeftbar } = useLeftbarBar();
  const { updateChannelData } = useContext(CreateChannelContext);
  const { channelEditData, updateChannelEditData, updateEditDataOnServer, updateStatus, originalState, loading } = useContext(EditChannelContext);

  const [touched, setTouched] = useState<Partial<Record<keyof SKChannel, boolean>>>({});

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    // Validate the field
    validateForm(name, value);
  };

  // const validateField = async (name: string, value: string) => {
  //   try {
  //     await schema.validateAt(name, { [name]: value });
  //     setErrors(prev => ({ ...prev, [name]: undefined })); // Remove error if valid
  //   } catch (error) {
  //     let err = error as Yup.ValidationError;
  //     setErrors(prev => ({ ...prev, [name]: err.message }));
  //   }
  // };

  const validateForm = async (name: string, value: any) => {
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      // if (inputFocused[name]) return false;
      setErrors(prev => ({ ...prev, [name]: error.message }));
      return false;
    }
  };

  const schema = Yup.object().shape({
    name: Yup.string().required("Name is required field"),
    description: Yup.string().required(),
    profileImageUrl: Yup.string().required(),
    backgroundImageUrl: Yup.string().required(),
    language: Yup.string().required().min(1),
    country: Yup.string().required(),
    topic: Yup.string().required(),
    age: Yup.string().required().min(1),
    certifyFirst: Yup.boolean().oneOf([true], "").required(),
    certifySecond: Yup.boolean().oneOf([true], "").required(),
    autoPublish: Yup.boolean().required(),
    subscriptionStatus: Yup.string().notRequired(),
    externalLinks: Yup.array()
      .of(
        Yup.object().shape({
          type: Yup.string().required(),
          value: Yup.string().notRequired(),
        })
      )
      .min(1, "At least one url is required")
      .required(),
    monthlySubscriptionId: Yup.string().when("subscriptionStatus", {
      is: true,
      then: schema => schema.required("monthlySubscriptionId is required when subscriptionStatus is true."),
      otherwise: schema => schema.nullable(),
    }),
    yearlySubscriptionId: Yup.string().when("subscriptionStatus", {
      is: true,
      then: schema => schema.required("yearlySubscriptionId is required when subscriptionStatus is true."),
      otherwise: schema => schema.nullable(),
    }),
    subscriptionImageUrl: Yup.string().when("subscriptionStatus", {
      is: true,
      then: schema => schema.required("subscriptionImageUrl is required when subscriptionStatus is true."),
      otherwise: schema => schema.nullable(),
    }),
    subscriptionVideoUrl: Yup.string().url("subscriptionVideoUrl must be a valid URL.").nullable(),
  });

  // useEffect(() => {
  //   if (!isEdit && channelData.status === ChannelState.DRAFT && channelData.subStatus === ChannelSubstate.NONE) {
  //     setShowLeftbar(false);
  //   }

  //   return () => {
  //     setShowLeftbar(true);
  //   };
  // }, [setShowLeftbar, channelData, isEdit]);

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getModerationDialogContent(actionOnItem.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);

  function getModerationDialogContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete this Channel?",
          description: "Channel and all its content will be permanently deleted form the system and cannot be recovered.",
          actionTitle: ActionItem.delete,
          destructiv: true,
        };
      case ActionItem.reject:
        return {
          message: "Are you sure you will like to Not Approve?",
          description: "Channel will move to inactive. User can submit again.",
          actionTitle: ActionItem.reject,
          destructiv: true,
        };

      case ActionItem.deactive:
        return {
          message: "Are you sure you will like to Deactivate Channel?",
          description: "Users will not be able to view this channel anymore.",
          actionTitle: ActionItem.deactive,
          destructiv: true,
        };
      case ActionItem.withdraw:
        return {
          message: "Are you sure you will like to Withdraw Channel?",
          description: "Channel will move to inactive state and no one can view your channel.",
          actionTitle: ActionItem.withdraw,
          destructiv: true,
        };
      case ActionItem.reject_edit:
        return {
          message: " Are you sure you will like to Reject Edits?",
          description: "Channel edits will be discarded. This action cannot be undone.",
          actionTitle: ActionItem.reject_edit,
          destructiv: true,
        };
      case ActionItem.approve:
        return {
          message: " Are you sure you will like to Approve Channel?",
          description: "Channel will be immediatly available to the public.",
          actionTitle: ActionItem.approve,
          destructiv: false,
        };
      case ActionItem.approve_edit:
        return {
          message: " Are you sure you will like to Approve Channel edits?",
          description: "Edits will be immediatly available to the public.",
          actionTitle: ActionItem.approve_edit,
          destructiv: false,
        };

      default:
        return null;
    }
  }

  const getPopItemsForId = (): ActionItem[] => {
    if (channelEditData) {
      const { status, subStatus } = channelEditData;
      return getCreatorActionableItems({ state: status, subState: subStatus });
    }
    return [];
  };

  useEffect(() => {
    const updateChannels = async () => {
      setIsLoading(true);
      if (channelEditData.status === ChannelState.ACTIVE) {
        if (originalState?.subStatus === ChannelSubstate.EDIT_IN_DRAFT || originalState?.subStatus === ChannelSubstate.EDIT_REJECTED) {
          channelEditData.id && updateStatus && (await updateStatus(channelEditData.id, ActionItem.edit_submit));
        }
      }
      setIsLoading(false);
    };

    location.pathname === "/dashboard/channels/editChannel" &&
      setNavProps({
        backArrow: false,
        title: "Channel",
        subtitle: channelEditData.status === ChannelState.DRAFT ? "Creator Channel" : authContext?.currentUser?.displayName ?? "",
        buttonTitle: "Submit",
        filterOption: false,
        getActionItems: getPopItemsForId().length > 0 ? getPopItemsForId : undefined,
        enableLink: isValidForm ? true : false,

        //isEdit ? channelEditData.status === ChannelState.IN_REVIEW ? false : channelEditData.status === ChannelState.ACTIVE ? true : isValidForm,
        onActionItemSelect: actionItem => {
          setActionOnItem({
            itemid: channelEditData.id!,
            action: actionItem as ActionItem,
          });
        },
        // enableLink: channelEditData.status === ChannelState.IN_REVIEW ? false : isValidForm,
        onBack: () => {
          navigate("../");
        },
        onNext:
          originalState?.status === ChannelState.ACTIVE &&
          (originalState?.subStatus === ChannelSubstate.EDIT_IN_DRAFT || originalState?.subStatus === ChannelSubstate.EDIT_REJECTED)
            ? updateChannels
            : undefined,

        // onNext1: () =>
        //   [ChannelState.IN_REVIEW, ChannelState.ACTIVE].includes(channelEditData.status)
        //     ? channelEditData.status === ChannelState.ACTIVE
        //       ? channelEditData.subStatus === ChannelSubstate.EDIT_IN_DRAFT
        //         ? updateChannels()
        //         : channelEditData.subStatus === ChannelSubstate.EDIT_IN_REVIEW
        //         ? undefined
        //         : requestEdit()
        //       : undefined
        //     : updateChannels(),
        // [ChannelState.IN_REVIEW, ChannelState.ACTIVE].includes(channelEditData.status)
        //   ? channelEditData.status === ChannelState.IN_REVIEW || channelEditData.subStatus === ChannelSubstate.EDIT_IN_REVIEW
        //     ? undefined
        //     : isEdit && channelEditData.subStatus === ChannelSubstate.EDIT_IN_DRAFT
        //     ? updateChannels()
        //     : undefined
        //   : channelEditData.status === ChannelState.DRAFT
        //   ? requestEdit()
        //   : updateChannels(),
        onEdit: undefined,
        onClose: async () => {
          if (originalState && originalState.subStatus !== ChannelSubstate.EDIT_IN_REVIEW) {
            updateEditDataOnServer && (await updateEditDataOnServer());
            updateChannelData(prev => ({ ...prev, editUpdateDate: Timestamp.now() }));
          }

          navigate(-1); // Go back
          // navigate(window.location.pathname, { replace: true });
        },
      });
  }, [isValidForm, setNavProps, navigate, channelEditData]);

  const requestEdit = async () => {
    navigate("../edit-channel");
  };

  useEffect(() => {
    const validate = async () => {
      const isExternalLinkValid = channelEditData.externalLinks?.some(link => link.value.trim() !== "");
      try {
        await schema.validate(channelEditData, { abortEarly: false });
        channelEditData.language !== "None" && channelEditData.country !== "None" && channelEditData.age && isExternalLinkValid
          ? setIsValidForm(true)
          : setIsValidForm(false);
      } catch (err) {
        let error = err as Yup.ValidationError;
        // setErrors(prev => ({ ...prev, [name]: error.message }));
        setIsValidForm(false);
        if (error.inner) {
          const errors: { path: string; message: string }[] = error.inner.map(error1 => ({
            path: error1.path || "unknown", // Field with the error
            message: error1.message, // Error message
          }));

          console.log("Validation errors:", errors);
        }
      }
    };
    validate();
  }, [channelEditData, schema]);

  const onChange = async (event: React.FocusEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    updateChannelEditData({ ...channelEditData, description: value });
    const isValid = await validateForm(name, value);
    const isValid2 = await validateForm("name", channelEditData.name ?? "");
    setIsEnabled(isValid && isValid2);
  };

  const handleImageChange = (index: number, fileUrl: string | null) => {
    updateChannelEditData(prev => ({ ...prev, profileImageUrl: fileUrl! }));
  };

  const handleBanerImage = (index: number, fileUrl: string | null) => {
    updateChannelEditData(prev => ({ ...prev, backgroundImageUrl: fileUrl! }));
  };
  const handlePromoImage = (index: number, fileUrl: string | null) => {
    updateChannelEditData(prev => ({ ...prev, promoMediaURL: fileUrl! }));
  };

  const resizeImage = (src: string, width: number, height: number, callback: (resizedDataUrl: string) => void) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
        const resizedDataUrl = canvas.toDataURL("image/jpeg");
        callback(resizedDataUrl);
      }
    };
    img.src = src;
  };

  // useEffect(() => {
  //   const isExternalLinkValid = channelEditData.externalLinks?.some(
  //     (link) => link.value.trim() !== ""
  //   );
  //   setNavProps({
  //     backArrow: false,
  //     title: "Channel",
  //     subtitle: "Details",
  //     buttonTitle: "Done",
  //     filterOption: true,
  //     enableLink:
  //       channelEditData.language !== "None" &&
  //       channelEditData.country !== "None" &&
  //       isExternalLinkValid
  //         ? true
  //         : false,
  //     onNext: () => updateChannels(),
  //     onClose: () => {
  //       navigate("../");
  //     },
  //   });
  // }, [setNavProps, channelEditData, updateChannels]);

  useEffect(() => {
    if (channelEditData.externalLinks) return;
    const links = [
      { type: "web_social", value: "" },
      { type: "optional", value: "" },
      { type: "optional", value: "" },
    ];
    updateChannelEditData(prev => ({
      ...prev,
      externalLinks: links,
    }));
  }, [channelEditData]);

  useEffect(() => {
    updateChannelEditData(prev => ({
      ...prev,
      secondLanguage: prev.secondLanguage || "optional",
    }));
  }, []);

  // const schema = Yup.object()
  //   .shape({
  //     language: Yup.string().required(`Primary Language is required!`),
  //     secondLanguage: Yup.string()
  //       .oneOf(
  //         [...iso6392.slice(120, 150).map((lang) => lang.iso6392B), "None"],
  //         "Invalid Secondary Language"
  //       )
  //       .notRequired(),
  //     country: Yup.string().required(`Country is required!`),
  //     primaryExternalLink: Yup.string().nullable(),
  //     secondaryExternalLink: Yup.string().nullable(),
  //     otherExternalLink: Yup.string().nullable(),
  //   })
  //   .test(
  //     "at-least-one-external-link",
  //     "At least one external link value is required.",
  //     (values) => {
  //       return Boolean(
  //         values.primaryExternalLink ||
  //           values.secondaryExternalLink ||
  //           values.otherExternalLink
  //       );
  //     }
  //   )
  //   .test(
  //     "at-least-one-url",
  //     "At least one URL must be provided and valid",
  //     (values) => {
  //       return !!(
  //         values.primaryExternalLink ||
  //         values.secondaryExternalLink ||
  //         values.otherExternalLink
  //       );
  //     }
  //   );

  // useEffect(() => {
  //   const validateAll = async () => {
  //     const data = {
  //       language: channelEditData.language,
  //       secondLanguage: channelEditData.secondLanguage,
  //       country: channelEditData.country,
  //       primaryExternalLink: (channelEditData.externalLinks && channelEditData.externalLinks[0]?.value) || "",
  //       secondaryExternalLink: (channelEditData.externalLinks && channelEditData.externalLinks[1]?.value) || "",
  //       otherExternalLink: (channelEditData.externalLinks && channelEditData.externalLinks[2]?.value) || "",
  //     };
  //     try {
  //       await schema.validate(data, { abortEarly: false });
  //       //setEnabled(true);
  //     } catch (error) {
  //       //setEnabled(false);
  //     }
  //   };

  //   validateAll();
  // }, [channelEditData, schema]);

  // const isoLanguages = [
  //   { title: "English", value: "eng" },
  //   ...iso6392
  //     .filter((lang) => lang.iso6392B !== "eng")
  //     .map((lang) => ({
  //       title: lang.name,
  //       value: lang.iso6392B,
  //     }))
  //     .sort((a, b) => a.title.localeCompare(b.title)),
  // ];

  const isoLanguages = [
    { title: "English", value: "eng" },
    ...iso6392
      .filter(lang => List_of_languages_to_be_displayed.includes(lang.name))
      .map(lang => ({
        title: lang.name,
        value: lang.iso6392B,
      }))
      .sort((a, b) => a.title.localeCompare(b.title)),
  ];

  const isoCountries = [
    { title: "United States", value: "USA" },
    ...iso31661
      .filter(country => country.alpha3 !== "USA")
      .map(country => ({ title: country.name, value: country.alpha3 }))
      .sort((a, b) => a.title.localeCompare(b.title)),
  ];

  const updateOption = (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;
    updateChannelEditData(prev => ({ ...prev, ...{ [name]: value } }));
  };

  return (
    <>
      <APILoader loading={loading} />
      {(isSubmitted || isLoading) && (
        <PopupSingleButtonProps
          popupContent={{
            title: isLoading ? "Submitting..." : "Successfully Submitted ",
            message: isLoading ? "Your channel is being submitted for review." : "Your channel is successfully submitted for review.",
            buttonTitle: "OK",
            status: isLoading ? PopupActionStatus.submitting : PopupActionStatus.success,
          }}
          onClose={async () => {
            isSubmitted && setIsSubmitted(false);
          }}
        />
      )}

      {actionOnItem?.action && dialogContent ? (
        <ArtifactStateDialog
          action={actionOnItem?.action}
          onClose={() => setActionOnItem(null)}
          onUpdate={async () => {
            const action = actionOnItem?.action;
            const contentId = actionOnItem?.itemid;
            updateStatus && contentId && (await updateStatus(contentId, action));
            setActionOnItem(null);
          }}
          dialogeContent={dialogContent}
        />
      ) : (
        <></>
      )}
      <div className="flex flex-col gap-[30px] channel-page-context">
        <div className="flex flex-col space-y-[10px] w-full">
          <div className="flex items-center">
            <AddTextField
              name={"name"}
              title={"Channel Name"}
              note={"This is the public name of your channel."}
              placeholder={"Name"}
              index={1}
              charAllowed={30}
              value={channelEditData.name}
              isCloseBtn={false}
              onChange={async e => {
                updateChannelEditData({ ...channelEditData, name: e.target.value });
                const { name, value } = e.target;
                const isValid = await validateForm(name, value);
                const isValid2 = await validateForm("description", channelEditData.description ?? "");
                setIsEnabled(isValid && isValid2);
              }}
              // onFocus={e => setInputFocused({ [e.target.name]: true })}
              // onBlur={e => setInputFocused({ [e.target.name]: false })}
              onBlur={handleBlur}
              notesclass="notes_inner_page"
              disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
              error={touched.name && errors.name ? errors.name : undefined}
            />
          </div>
        </div>
        <div className="flex flex-col space-y-[10px] w-full">
          <div className="relative w-full min-w-[200px] mb-2">
            <AddTextAreaField
              index={2}
              name={"description"}
              title={"Channel Description"}
              note={"Share a brief description about your channel and content."}
              placeholder={"Enter Description"}
              height={150}
              charAllowed={500}
              value={channelEditData.description as string}
              onChange={onChange}
              notesclass="notes_inner_page"
              disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
              onBlur={handleBlur}
            />
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div>
            <div className="flex items-center">
              <span>
                <span className="content_count">3</span>
              </span>
              <span className="content_title">Channel Profile Photo</span>
            </div>
            <div>
              <label className="notes_inner_page">Recommended resolution 360 x 360.</label>
            </div>

            <div className="mt-[15px] rounded-[12px]">
              <ImageInput
                key={0}
                index={3}
                onFileChange={handleImageChange}
                docId={channelEditData.id!}
                folder={FolderName.channel}
                maxFileSize={1}
                fileTypeShow="JPG, PNG, or HEIF"
                imageUrl={channelEditData.profileImageUrl}
                imageWidth={180}
                imageHeight={180}
                editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
              />
            </div>
            {errors.profImageError && <span className="remaining-characters">{errors.profImageError}</span>}
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="flex items-center">
            <span>
              <span className="content_count">4</span>
            </span>
            <span className="content_title">Channel Background Photo</span>
          </div>
          <div>
            <label className="notes_inner_page">Recommended resolution 780 x 260.</label>
          </div>
          <div className="mt-[15px] rounded-[12px]">
            <ImageInput
              key={0}
              index={4}
              onFileChange={handleBanerImage}
              docId={channelEditData.id!}
              folder={FolderName.channel}
              maxFileSize={1}
              imageUrl={channelEditData.backgroundImageUrl}
              fileTypeShow="JPG, PNG, or HEIF"
              imageWidth={450}
              imageHeight={150}
              editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
            />
          </div>
          {errors.bannerImgageError && <span className="remaining-characters">{errors.bannerImgageError}</span>}
        </div>
        <div className="flex flex-col w-full">
          <div className="flex items-center">
            <span>
              <span className="content_count">5</span>
            </span>
            <span className="content_title">Add Promotional Photo</span>
          </div>
          <div>
            <label className="notes_inner_page">
              We may show this photo on your subscription paywall and in key promotional areas. Recommended aspect ratio of photo is either 4:3, 1:1,
              or 3:4.
            </label>
          </div>
          <div className="mt-[15px] rounded-[12px]">
            <ImageInput
              index={5}
              onFileChange={handlePromoImage}
              docId={channelEditData.id!}
              folder={FolderName.channel}
              maxFileSize={1}
              fileTypeShow="JPG, PNG, or HEIF"
              imageUrl={channelEditData.promoMediaURL}
              imageWidth={180}
              imageHeight={180}
              editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
            />
          </div>
          {errors.promoMediaURL && <span className="remaining-characters">{errors.promoMediaURL}</span>}
        </div>
        <div className="items-center lex">
          <div className="flex items-center">
            <SKSelectOption
              index={6}
              name="language"
              value={channelEditData.language}
              heading="Channel Languages"
              subHeading={"Choose the primary language of your channel. You can still post in other languages."}
              width={"w-[290px]"}
              options={isoLanguages}
              onUpdate={e => updateOption(e)}
              marginBottom="mb-[15px]"
              editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
            />
          </div>

          <div className="flex items-center">
            <SKSelectOption
              name="secondLanguage"
              value={channelEditData.secondLanguage || "optional"}
              heading=""
              subHeading={"Choose the secondary language of your channel if applicable."}
              width={"w-[290px]"}
              options={[{ title: "Optional", value: "optional" }, ...isoLanguages]}
              onUpdate={e => updateOption(e)}
              marginBottom="mb-[0px]"
              editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
            />
          </div>
        </div>

        <div className="flex items-center">
          <SKSelectOption
            index={7}
            value={channelEditData.country}
            name="country"
            heading="Channel's Home Country"
            subHeading={"Choose the the home country where you channel is based."}
            width={"w-[290px]"}
            options={isoCountries}
            onUpdate={e => updateOption(e)}
            marginBottom="mb-[0px]"
            editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
          />
        </div>
        <div className="flex flex-col gap-[10px]">
          <div className="flex flex-col w-full">
            <div className="relative inline-block w-full text-left">
              <SKSelectOption
                id="Link_1"
                index={8}
                value={channelEditData.externalLinks?.[0]?.type || "web_social"}
                heading="External Links"
                subHeading="Choose important external links you would like your followers to have access to."
                width="w-[290px]"
                options={[{ title: "Website", value: "web_social" }, ...sortedExternalLinkOptions]}
                //options={sortedExternalLinkOptions}
                selectedIndex={1}
                onUpdate={e => {
                  const { value } = e.target;
                  let externalLinks = channelEditData.externalLinks || [];
                  externalLinks[0] = {
                    type: value,
                    value: externalLinks[0]?.value || "",
                  };
                  updateChannelEditData(prev => ({ ...prev, externalLinks }));
                }}
                marginBottom="mb-[15px]"
                editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
              />
            </div>
            <div className="flex items-center">
              <AddTextField
                id={"primaryExternalLink"}
                name={"primaryExternalLink"}
                title={""}
                note={""}
                placeholder={"Add Link"}
                charAllowed={50}
                value={channelEditData.externalLinks ? channelEditData.externalLinks[0].value ?? "" : ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { name, value } = e.target;
                  let externalLinks = channelEditData.externalLinks;
                  if (externalLinks && externalLinks.length >= 1) {
                    externalLinks[0] = {
                      type: externalLinks[0].type,
                      value: value,
                    };
                  }
                  updateChannelEditData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                  await validateForm("externalLinks", externalLinks);
                }}
                showRemainingChar={false}
                disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
              />
            </div>

            {errors.primaryExternalLink && <span className="remaining-characters">{errors.primaryExternalLink}</span>}
          </div>
          <div className="flex flex-col w-full">
            <div className="relative inline-block w-8/12 text-left">
              <SKSelectOption
                id="Link_2"
                value={channelEditData.externalLinks?.[1]?.type || "optional"}
                selectedIndex={2}
                heading=""
                subHeading={""}
                width={"w-[290px]"}
                options={[{ title: "Optional", value: "optonal" }, ...sortedExternalLinkOptions]}
                onUpdate={e => {
                  const { name, value } = e.target;
                  let externalLinks = channelEditData.externalLinks;
                  if (externalLinks && externalLinks.length >= 2) {
                    externalLinks[1] = {
                      type: value,
                      value: externalLinks[1].value,
                    };
                  } else {
                    while (externalLinks && externalLinks.length < 2) {
                      externalLinks?.push({ type: "optional", value: "" });
                    }
                    externalLinks?.push({ type: value, value: "" });
                  }
                  updateChannelEditData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                }}
                marginBottom="mb-[15px]"
                editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
              />
            </div>

            <div className="flex items-center">
              <AddTextField
                id={"secondaryExternalLink"}
                name={"secondaryExternalLink"}
                title={""}
                note={""}
                placeholder={"Add Link"}
                charAllowed={50}
                value={channelEditData.externalLinks?.[1]?.value ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { name, value } = e.target;
                  let externalLinks = channelEditData.externalLinks;
                  if (externalLinks && externalLinks.length >= 2) {
                    externalLinks[1] = {
                      type: externalLinks[1].type,
                      value: value,
                    };
                  } else {
                    // fill gaps if needed
                    while (externalLinks && externalLinks.length < 2) {
                      externalLinks.push({ type: "optional", value: "" });
                    }
                    externalLinks?.push({ type: "optional", value });
                  }
                  updateChannelEditData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                  await validateForm("externalLinks", externalLinks);
                  // await validateForm(name, value);
                }}
                showRemainingChar={false}
                disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
              />
            </div>

            {errors.secondaryExternalLink && <span className="block text-sm text-red-600 dark:text-red-500">{errors.secondaryExternalLink}</span>}
          </div>
          <div className="flex flex-col w-full">
            <div className="relative inline-block w-8/12 text-left">
              <SKSelectOption
                id="Link_3"
                value={channelEditData.externalLinks?.[2]?.type || "optional"}
                selectedIndex={3}
                heading=""
                subHeading={""}
                width={"w-[290px]"}
                options={[{ title: "Optional", value: "optional" }, ...sortedExternalLinkOptions]}
                onUpdate={e => {
                  const { name, value } = e.target;
                  let externalLinks = channelEditData.externalLinks;
                  if (externalLinks && externalLinks?.length >= 3) {
                    externalLinks[2] = {
                      type: value,
                      value: externalLinks[2].value,
                    };
                  } else {
                    externalLinks?.push({ type: value, value: "" });
                  }
                  updateChannelEditData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                }}
                marginBottom="mb-[15px]"
                editable={originalState?.subStatus !== ChannelSubstate.EDIT_IN_REVIEW}
              />
            </div>

            <div className="flex items-center">
              <AddTextField
                id={"otherExternalLink"}
                name={"otherExternalLink"}
                title={""}
                note={""}
                placeholder={"Add Link"}
                charAllowed={50}
                value={channelEditData.externalLinks?.[2]?.value ?? ""}
                isCloseBtn={false}
                onChange={async e => {
                  const { name, value } = e.target;
                  let externalLinks = channelEditData.externalLinks;
                  if (externalLinks && externalLinks?.length >= 3) {
                    externalLinks[2] = { type: externalLinks[2].type, value };
                  } else {
                    // fill gaps if needed
                    while (externalLinks && externalLinks.length < 3) {
                      externalLinks.push({ type: "optional", value: "" });
                    }
                    externalLinks?.push({ type: "optional", value });
                  }
                  updateChannelEditData(prev => ({
                    ...prev,
                    externalLinks,
                  }));
                  await validateForm("externalLinks", externalLinks);
                  // await validateForm(name, value);
                }}
                showRemainingChar={false}
                disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
              />
            </div>

            {errors.otherExternalLink && <span className="remaining-characters">{errors.otherExternalLink}</span>}
          </div>
        </div>
        <ChannelCheckListCard
          index={9}
          name="Topic"
          title="Topic"
          purposeText="Add Topic"
          notes="Topic that represents the primary focus of channel content."
          doneText={channelEditData.topic ? capitalizeFirstLetter(TopicTypeString[channelEditData.topic]) : undefined}
          action={() => {
            navigate("../topic");
          }}
          disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
        />
        <ChannelCheckListCard
          index={10}
          name="Age Rating"
          title="Age Rating"
          purposeText="Add Age Rating"
          notes="Safety age rating for children."
          doneText={channelEditData.age ? "Age " + channelEditData.age + "+" : undefined}
          action={() => {
            navigate("../age");
          }}
          disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
        />
        <ChannelCheckListCard
          index={11}
          name="Channel Safety"
          title="Channel Safety"
          purposeText="Certify Content"
          notes="Certify that your content is safe and follows Skarvo Content Guidelines."
          doneText={channelEditData.certifyFirst && channelEditData.certifySecond ? "Certified" : undefined}
          action={() => {
            navigate("../certification");
          }}
          disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
        />
        <ChannelSubscriptionType
          index={12}
          disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
          channelData={channelEditData}
          updateChannelData={updateChannelEditData}
        />
        {(channelEditData.subscriptionStatus === Tier.paid || channelEditData.subscriptionStatus === Tier.freeNpaid) && (
          <>
            <AddTextField
              index={13}
              id={"expectedMonthlySubscriptionPrice"}
              name={"expectedMonthlySubscriptionPrice"}
              title={"Monthly Price in USD"}
              note={"This is what subscribers will pay each month to access your paid content."}
              footNote="Enter a valid amount using numbers and a decimal (e.g. 1.99)."
              placeholder={"Expected monthly amount"}
              charAllowed={50}
              value={channelEditData.expectedMonthlySubscriptionPrice ?? ""}
              isCloseBtn={false}
              onChange={async e => {
                const { value } = e.target;
                updateChannelEditData(prev => ({
                  ...prev,
                  expectedMonthlySubscriptionPrice: value,
                }));
              }}
              showRemainingChar={false}
              error={errors.expectedMonthlySubscriptionPrice}
              disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
            />

            <AddTextField
              index={14}
              id={"expectedYearlySubscriptionPrice"}
              name={"expectedYearlySubscriptionPrice"}
              title={"Yearly Price in USD"}
              note={"This is what subscribers will pay each year to access your paid content."}
              footNote="Enter a valid amount using numbers and a decimal (e.g. 1.99)."
              placeholder={"Expected monthly amount"}
              charAllowed={50}
              value={channelEditData.expectedYearlySubscriptionPrice ?? ""}
              isCloseBtn={false}
              onChange={async e => {
                const { value } = e.target;
                updateChannelEditData(prev => ({
                  ...prev,
                  expectedYearlySubscriptionPrice: value,
                }));
              }}
              showRemainingChar={false}
              error={errors.expectedYearlySubscriptionPrice}
              disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
            />
            <OptionSelect
              index={15}
              title="Adjust Prices by Country"
              subTitle="Make your content more affordable for global audiences."
              value={channelEditData.adjustSubscriptionPriceByCountry ?? false}
              options={[
                { id: 1, title: "Yes", value: true, description: "Adjust prices by country’s pruchasing power." },
                { id: 2, title: "No", value: false, description: "Prices will remain the same worldwide, based on the USD amounts you set." },
              ]}
              onSelect={val => {
                const adjustSubscriptionPriceByCountry: boolean = (val as boolean) ?? false;
                updateChannelEditData(prev => ({
                  ...prev,
                  adjustSubscriptionPriceByCountry,
                }));
              }}
              error={errors.adjustSubscriptionPriceByCountry}
              disabled={originalState?.subStatus === ChannelSubstate.EDIT_IN_REVIEW}
            />
          </>
        )}
      </div>
    </>
  );
}
